<template lang="pug">
  #friends
    WtTile(ancestor vertical)
      BLoading(:active.sync="fullPageLoader" :is-full-page="true")
      WtTile(parent)
        .friends-header.level.is-mobile.is-custom-mobile
          .level-left
            .level-item
              WtTitle(h1) Friends
          .level-right
            FindNewFriends(
              v-if="!_.isEmpty(memberFriends)"
            )

      WtTile(parent vertical)
        section.section.empty-state(v-if="_.isEmpty(memberFriends)")
          FindNewFriends
        MyFriends(v-else-if="friendsLoaded")

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtButton from "@/components/WtButton/WtButton";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import MyFriends from "@@/Friends/FriendsMyFriends";
import FindNewFriends from "@@/Friends/FriendsFindNewFriends";
import { fetchAllMixin } from "@/mixins/fetchAllMixin";
import analyticsTrackingMixin from "@/mixins/analyticsTrackingMixin";

export default {
  name: "Friends",

  components: {
    WtButton,
    WtTile,
    WtTitle,
    MyFriends,
    FindNewFriends
  },

  mixins: [analyticsTrackingMixin, fetchAllMixin],

  data() {
    return {
      page: "Friends"
    };
  },

  computed: {
    ...mapGetters("pages", ["isPageLoaded", "isPageLoading"]),
    ...mapGetters("members", [
      "memberFriends",
      "friendsLoaded",
      "friendsInvited",
      "friendsInvitedLoaded",
      "friendsRequesting",
      "friendsRequestingLoaded"
    ]),

    fullPageLoader() {
      // since there is no intial state for 'isPageLoading(this.page)'
      if (this._.isUndefined(this.isPageLoading(this.page))) {
        return true;
      }
      return this.isPageLoading(this.page);
    }
  },

  async mounted() {
    this.trackFeatureView("community", "community_friends");
    await this.toFetchOrNotToFetch(this, this.page, {
      force: !this.isPageLoading(this.page)
    });
  },

  methods: {
    ...mapActions("members", ["fetchFriendsInvited", "fetchFriendsRequesting"]),
    ...mapActions("pages", [
      "fetchAllPageFriends",
      "setPageLoading",
      "setPageLoaded"
    ]),
    ...mapActions(["snackBar"]),

    async fetchAllPage(vm) {
      const memberId = vm.$auth.user().id;

      await vm.fetchAllPageFriends(memberId);
    }
  }
};
</script>

<style lang="sass" scoped>
#friends
  .my-friends
    min-height: 425px
  .find-new-friends
    max-height: 425px
    min-height: 425px
  .friends-header
    width: 100%
  .is-custom-mobile
    @media screen and (max-width: 480px)
      flex-direction: column
      align-items: flex-start
    .level-right
      @media screen and (max-width: 480px)
        margin: 1rem 0 !important
</style>
